module.exports = __webpack_public_path__ + "static/media/Beach-min.64e108c5.png";